<template>
  <div style="overflow-x: auto; overflow-y: hidden; padding: 14px; margin: 6px 0">
    <div v-if="items && items.length > 0">
      <chart-sorter v-model="sorting" :sorting-items="sortingItems" />
      <mf-toggle
        v-model="showQuantity"
        class="pl-5 ma-0 pt-3 pb-3"
        :label="showQuantity ? 'Visualizar por valor (R$)' : 'Visualizar por quantidade'"
        hide-details
      />

      <quantity-chart
        v-if="showQuantity"
        :selected-units="selectedUnits"
        :items="items"
        :offer-type-name="offerTypeName"
        :offer-type-name-capital="offerTypeNameCapital"
        :sorting="sorting"
        :hide-earn="isZeDelivery"
      />
      <value-chart
        v-else
        :selected-units="selectedUnits"
        :items="items"
        :offer-type-name="offerTypeName"
        :offer-type-name-capital="offerTypeNameCapital"
        :sorting="sorting"
        :hide-earn="isZeDelivery"
      />
    </div>
    <chart-empty-state v-else />
  </div>
</template>

<script>
import QuantityChart from './QuantityChart.vue'
import ValueChart from './ValueChart.vue'
import ChartSorter from './ChartSorter.vue'
import ChartEmptyState from '@/components/campaigns/ChartEmptyState.vue'

export default {
  name: 'BenefitValuesChart',
  components: {
    QuantityChart,
    ValueChart,
    ChartSorter,
    ChartEmptyState,
  },
  props: {
    selectedUnits: {
      type: Array,
      required: true,
    },
    items: {
      type: Array,
      default(_) {
        return []
      },
    },
    offerType: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    sorting: 'bc-desc',
    showQuantity: false,
  }),
  computed: {
    sortingItems() {
      let sortingItems = []
      if (!this.isZeDelivery) {
        sortingItems.push({
          sortBy: 'bg',
          name: `${this.offerTypeNameCapital} gerado`,
          legendColor: '#002040',
        })
      }
      sortingItems.push({
        sortBy: 'bc',
        name: `${this.offerTypeNameCapital} consumido`,
        legendColor: '#94b300',
      })
      return sortingItems
    },

    isNextbuyCashback() {
      return this.offerType === 'nextbuycashback'
    },

    isDigitalVoucher() {
      return this.offerType === 'dynamic_rule'
    },

    isZeDelivery() {
      return this.offerType === 'benefits'
    },

    offerTypeName() {
      return this.isNextbuyCashback ? 'cashback' : this.isDigitalVoucher || this.isZeDelivery ? 'voucher' : ''
    },

    offerTypeNameCapital() {
      return this.isNextbuyCashback ? 'Cashback' : this.isDigitalVoucher || this.isZeDelivery ? 'Voucher' : ''
    },
  },
}
</script>
